import React from 'react';
import Finded from '../../Component/FindedBio/Finded';

const FindHome = () => {
  

  
    return (
        <div>
     
              
                     <Finded />
                
        </div>
    );
};

export default React.memo(FindHome);